import { createUseStyles } from 'react-jss'
import { SELECTED_BORDER, shadows } from 'src/config/styles'
import { typography } from '@dentalux/ui-library-core'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: 440,
    boxSizing: 'border-box',
    padding: '1px 8px',
    margin: '0 auto',
    [forPhoneOnly]: {
      padding: '0 16px 8px',
    },
  },
  districtContainer: {
    background: theme.palette.common.white,
    borderRadius: 8,
    padding: 16,
    ...typography['Lato Emphasized 1'],
    boxShadow: shadows[1],
    display: 'flex',
    color: theme.palette.grey[800],
    gap: 16,

    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.grey['100'],
    },
    [forPhoneOnly]: {
      padding: 12,
    },
  },

  clinicCount: {
    ...typography['Lato Emphasized 2'],
    color: theme.palette.primary.main,
    background: theme.palette.primary.light,
    borderRadius: '100%',
    padding: '2px 7.5px',
  },

  selected: {
    border: SELECTED_BORDER(theme),
  },
}))
